import { Lead, IcpPriority } from '../types/lead'

export interface ScoreBreakdownItem {
  rule: string
  points: number
  applied: boolean
}

export interface ScoringResult {
  score: number
  breakdown: ScoreBreakdownItem[]
  icpPriority: IcpPriority
}

export function calculateLeadScore(lead: Partial<Lead>): ScoringResult {
  let score = 0
  const breakdown: ScoreBreakdownItem[] = []

  // 1. Sin Sitio Web Propio: +40
  const noWeb = lead.ESTADO_WEB_MENU === 'No web'
  if (noWeb) score += 40
  breakdown.push({ rule: 'Sin Sitio Web Propio', points: 40, applied: noWeb })

  // 2. Menú solo en papel / PDF no usable: +25
  const badMenu = lead.MENU_STATUS === 'Papel' || lead.MENU_STATUS === 'PDF'
  if (badMenu) score += 25
  breakdown.push({
    rule: 'Menú solo en papel / PDF no usable',
    points: 25,
    applied: badMenu,
  })

  // 3. Web obsoleta / No responsive: +20
  const oldWeb = lead.ESTADO_WEB_MENU === 'Web obsoleta'
  if (oldWeb) score += 20
  breakdown.push({
    rule: 'Web obsoleta / No responsive',
    points: 20,
    applied: oldWeb,
  })

  // 4. Ficha Google (GMB) incompleta: +10
  const gmbIncomplete = !lead.ENLACE_GMB || lead.ENLACE_GMB.trim() === ''
  if (gmbIncomplete) score += 10
  breakdown.push({
    rule: 'Ficha Google (GMB) incompleta',
    points: 10,
    applied: gmbIncomplete,
  })

  // 5. Redes Sociales inactivas / inexistentes: +10
  const rrssInactive =
    !lead.RRSS_HANDLES?.instagram && !lead.RRSS_HANDLES?.facebook
  if (rrssInactive) score += 10
  breakdown.push({
    rule: 'Redes Sociales inactivas / inexistentes',
    points: 10,
    applied: rrssInactive,
  })

  // 6. Propietario visible: +10
  const propVisible = !!lead.hasPropietarioVisible
  if (propVisible) score += 10
  breakdown.push({
    rule: 'Propietario visible',
    points: 10,
    applied: propVisible,
  })

  // 7. Buen volumen de reseñas: +5
  const goodReviews = !!lead.hasBuenVolumenResenas
  if (goodReviews) score += 5
  breakdown.push({
    rule: 'Buen volumen de reseñas',
    points: 5,
    applied: goodReviews,
  })

  let icpPriority: IcpPriority = 'C'
  if (score >= 60) icpPriority = 'A'
  else if (score >= 40) icpPriority = 'B'

  return { score, breakdown, icpPriority }
}

export function calculateEvidenceCompleteness(lead: Partial<Lead>): number {
  let filled = 0
  const total = 5

  if (lead.DECISOR_NOMBRE && lead.DECISOR_NOMBRE.trim() !== '') filled++
  if (lead.VERIFICADO) filled++
  if (lead.MICRO_ACCION_TYPE) filled++
  if (lead.MICRO_ACCION_DATE) filled++
  if (lead.TEXTO_EVIDENCIA && lead.TEXTO_EVIDENCIA.trim() !== '') filled++

  return Math.round((filled / total) * 100)
}
